import { PopoverPopup } from "../popover/popup.js";
import { useVolumePopoverContext } from "./context.js";
import { VolumePopoverDataAttrs } from "@videojs/core";
import { getStateDataAttrs } from "@videojs/core/dom";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/ui/volume-popover/popup.tsx
/** Positioned volume content. Omitted when volume level controls are unavailable. */
const VolumePopoverPopup = forwardRef(function VolumePopoverPopup(props, forwardedRef) {
	const { state } = useVolumePopoverContext();
	if (state.hidden) return null;
	return /* @__PURE__ */ jsx(PopoverPopup, {
		ref: forwardedRef,
		...getStateDataAttrs(state, VolumePopoverDataAttrs),
		...props
	});
});
//#endregion
export { VolumePopoverPopup };

//# sourceMappingURL=popup.js.map